import axiosInstance from '../../Config/axiosConfig';

export const getLikesMe = async () => {
  try {
    const response = await axiosInstance.get('/user/likes-me');
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const getMyLikes = async () => {
  try {
    const response = await axiosInstance.get('/user/my-likes');
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const getViewedMe = async () => {
  try {
    const response = await axiosInstance.get('/user/viewed-me');
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

